import { createTheme } from '@mui/material/styles';
import { ThemeConfig } from 'antd';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#001350',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FF5D00',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
    text: {
      primary: '#001350',
      secondary: '#475569',
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    h5: {
      color: '#001350',
      fontWeight: 600,
    },
    h6: {
      color: '#001350',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#001350',
          '&:hover': {
            backgroundColor: '#001f80',
          },
        },
        containedSecondary: {
          backgroundColor: '#FF5D00',
          '&:hover': {
            backgroundColor: '#ff7a33',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
        },
      },
    },
  },
});

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#001350',
    colorInfo: '#001350',
    colorSuccess: '#52c41a',
    colorWarning: '#FF5d00',
    colorError: '#f5222d',
    borderRadius: 4,
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  },
  components: {
    Layout: {
      siderBg: '#001350',
      headerBg: '#ffffff',
    },
    Menu: {
      darkItemBg: '#001350',
      darkItemSelectedBg: '#001f80',
    },
    Button: {
      primaryColor: '#ffffff',
    },
  },
};

export default theme;
